export default __webpack_public_path__ + "static/media/dozule16.facefc6e.jpg";